<div
  class="image-tile"
  [reactComponent]="imageTileComponent"
  [props]="{
    imgUrl: logoSrc,
    altText: logoAlt
  }"
></div>
<div class="order-status-preview-content">
  <progress-bar [fragments]="fragments"></progress-bar>
  <div class="order-status-preview-content-title ods-typography-subtitle-s">{{ title | translate }}</div>
  <span class="order-status-preview-content-instructions">{{ 'you_can_see_more_info' | translate }}</span>
</div>
<div class="order-status-preview-icon">
  <svg class="order-status-preview-icon-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="m8 17 5-5-5-5 2-1 6 6-6 6-2-1Z" />
  </svg>
</div>
